module.exports = __webpack_public_path__ + "img/sign-out-alt-s.2a33ebdf.svg";